import {defineSlotRecipe} from '@chakra-ui/react3'

export const thumbsSlotRecipe = defineSlotRecipe({
    slots: [
        'container',
        'controlsContainer',
        'buttonGroup',
        'navButton',
        'scrollContainer',
        'slide'
    ],

    base: {
        container: {
            position: 'absolute',
            inset: 0,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            '--items-per-page': 6,
            '--thumb-size': 'sizes.20',
            '--thumb-gap': 'sizes.4'
        },

        controlsContainer: {
            position: 'absolute',
            paddingTop: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            inset: 0,
            pointerEvents: 'none'
        },

        buttonGroup: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%',
            justifyContent: 'space-between',
            pointerEvents: 'none'
        },

        navButton: {
            variant: 'secondaryGhost',
            size: 'md',
            pointerEvents: 'auto'
        },

        scrollContainer: {
            overflowY: 'auto',
            overflowX: 'hidden',
            scrollSnapType: 'y mandatory',
            display: 'flex',
            flexDirection: 'column',
            minW: 0,
            scrollbarWidth: 'none',
            gap: 'var(--thumb-gap)',
            height: '100%',
            paddingY: 0,
            borderRadius: {s: 'm'},
            marginY: '3.5rem'
        },

        slide: {
            flex: '0 0 auto',
            flexShrink: 0,
            width: '100%',
            borderRadius: 'm',
            overflow: 'hidden',
            position: 'relative',
            display: 'block',
            background: 'background.section.default',
            aspectRatio: 1,

            _current: {
                _after: {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 'inherit',
                    pointerEvents: 'none',
                    zIndex: 2,
                    boxShadow: 'inset 0 0 0 1px {colors.background.actions.primary}'
                }
            }
        }
    },

    variants: {
        shouldHideControls: {
            true: {
                controlsContainer: {display: 'none'},
                scrollContainer: {marginY: 0}
            },
            false: {}
        }
    },

    defaultVariants: {shouldHideControls: false}
})
